export class Appliance {
	id: number;
	name: string;
	power: number;
	iconUrl: string;
	applianceCategoryId: string;
	applianceCategory: string;

	constructor({ id, name, iconUrl, power, applianceCategoryId,applianceCategory  }: Appliance) {
		this.id = id;
		this.name = name;
		this.power = power;
		this.iconUrl = iconUrl;
		this.applianceCategory = applianceCategory;
		this.applianceCategoryId = applianceCategoryId;
	}
}

export interface ProductCategory {
    id: string;
	name: string;
	imageUrl: string;
	isCategoryEmpty: true;
}
